module.exports = "/images/Australia.png?608599453306500b7c3174b5574c44a8";